import React, { Fragment, useCallback, useEffect, useState } from "react";
import CounterCard from "./Dashboard/CounterCard";
import { editorDashboardAPI,editorDashboardOfferAPI } from "../../api/dashboard";
import moment from "moment";

function EditorDashboard() {
  const [counts, setCounts] = useState({});
  const [offers, setOffers] = useState({});

  const getDashboardData = useCallback(() => {
    editorDashboardAPI().then((res) => {
      //console.log(res);
      setCounts(res);
    });
  }, [setCounts]);

  const getDashboardOfferData = useCallback(() => {
    editorDashboardOfferAPI().then((res) => {
      //console.log(res);
      setOffers(res);
    });
  }, [setOffers]);

  useEffect(() => {
    getDashboardData();
  }, [getDashboardData]);

  useEffect(() => {
    getDashboardOfferData();
  }, [getDashboardOfferData]);

  return (
    <Fragment>
      <div className="card">
        <div className="card-body">
          <h2 className="card-title">Over All Applicants</h2>
          <div className="row">
            <CounterCard
              title={counts?.overall_unlock_quota}
              subtitle="Over All Unlock Quota"
              link=""
              iconClass="fas fa-database"
              cssClass="success"
            />
            <CounterCard
              title={counts?.overall_total_unlocked}
              subtitle="Over All Total Unlocked"
              link=""
              iconClass="fas fa-unlock"
              cssClass="info"
            />
            <CounterCard
              title={counts?.overall_total_favourites}
              subtitle="Over All Total Favourites"
              link=""
              iconClass="fas fa-star"
              cssClass="primary"
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <h2 className="card-title">
            Applicants ({moment().format("MMMM-yyyy")})
          </h2>
          <div className="row">
            <CounterCard
              title={counts?.total_unlock_quota}
              subtitle="Total Unlock Quota"
              link=""
              iconClass="fas fa-database"
              cssClass="success"
            />
            <CounterCard
              title={counts?.total_unlocked}
              subtitle="Total Unlocked"
              link=""
              iconClass="fas fa-unlock"
              cssClass="info"
            />
            <CounterCard
              title={counts?.total_unlock_balance}
              subtitle="Unlock Balance"
              link=""
              iconClass="fas fa-lock"
              cssClass="warning"
            />
            <CounterCard
              title={counts?.total_favourites}
              subtitle="Total Favourites"
              link=""
              iconClass="fas fa-star"
              cssClass="primary"
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <h2 className="card-title">
            Your Offers
          </h2>
          <div className="row">
            <CounterCard
              title={offers?.offered}
              subtitle="Total Offered"
              link=""
              iconClass="fas fa-database"
              cssClass="success"
            />
            <CounterCard
              title={offers?.joined}
              subtitle="Total Joined"
              link=""
              iconClass="fas fa-unlock"
              cssClass="info"
            />
            <CounterCard
              title={offers?.declined}
              subtitle="Total Declined"
              link=""
              iconClass="fas fa-lock"
              cssClass="warning"
            />
            <CounterCard
              title={offers?.dropped_90_days}
              subtitle="Dropped within 90 Days"
              link=""
              iconClass="fas fa-star"
              cssClass="primary"
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <h2 className="card-title">Jobs ({moment().format("MMMM-yyyy")})</h2>
          <div className="row">
            <CounterCard
              title={counts?.total_jobs}
              subtitle="Total Jobs"
              link=""
              iconClass="fas fa-database"
              cssClass="success"
            />
            <CounterCard
              title={counts?.total_applicants}
              subtitle="Total Applicants"
              link=""
              iconClass="fas fa-users"
              cssClass="info"
            />
            <CounterCard
              title={counts?.live_on_site}
              subtitle="Live Jobs"
              link=""
              iconClass="fas fa-globe"
              cssClass="warning"
            />
            <CounterCard
              title={counts?.hot_jobs}
              subtitle="Hot Jobs"
              link=""
              iconClass="fas fa-bullhorn"
              cssClass="primary"
            />
            <CounterCard
              title={counts?.tech_jobs}
              subtitle="Tech Jobs"
              link=""
              iconClass="fas fa-cogs"
              cssClass="info"
            />
            <CounterCard
              title={counts?.non_tech_jobs}
              subtitle="Non-tech Jobs"
              link=""
              iconClass="fas fa-briefcase"
              cssClass="secondary"
            />

            <CounterCard
              title={counts?.lgbtq_talent}
              subtitle="LGBT+ Talent"
              link=""
              iconClass="fas fa-transgender"
              cssClass="primary"
            />
            <CounterCard
              title={counts?.women_talent}
              subtitle="Women Talent"
              link=""
              iconClass="fas fa-female"
              cssClass="info"
            />
            {/* <CounterCard
              title={counts?.man_talent}
              subtitle="Men Talent"
              link=""
              iconClass="fas fa-male"
              cssClass="warning"
            /> */}
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default EditorDashboard;
